import { memo, SVGProps } from 'react';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
        <stop stopColor="#C287FF" offset="0%" />
        <stop stopColor="#AE84FF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="2.56279365%"
        y1="45.604914%"
        x2="100%"
        y2="60.8221918%"
        id="linearGradient-2"
      >
        <stop stopColor="#FB7AFF" offset="0%" />
        <stop stopColor="#B28AFF" offset="100%" />
      </linearGradient>
      <path
        d="M2.00837657,0.504950388 C3.17630585,-0.326501218 5.63657832,0.0697402703 8.77701953,0.287345329 C11.9174607,0.504950388 13.5060362,-0.00110713663 15.1184417,0.287345329 C16.1470684,0.471362247 17.0083766,1.2498961 17.0083766,2.68735717 C17.0083766,3.84732508 17.0083766,8.18059566 17.0083766,10.8975581 C17.0083766,11.7686173 15.7613612,12.4293039 15.1184417,12.6538865 C13.8963613,13.0807799 11.3422335,13.0588636 8.77701953,12.6538865 C6.86788285,12.352486 4.58841738,12.1403149 2.85106864,12.5676428 C1.96816627,12.7848064 1.35393558,13.2732345 1.00837657,14.032927 C1.00837657,8.8597046 1.00837657,5.65864944 1.00837657,4.42976153 C1.00837657,2.38070596 0.84044729,1.33640199 2.00837657,0.504950388 Z"
        id="path-3"
      />
      <filter
        x="-6.2%"
        y="-7.1%"
        width="112.5%"
        height="114.3%"
        filterUnits="objectBoundingBox"
        id="filter-4"
      >
        <feGaussianBlur
          stdDeviation={0.5}
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx={1}
          dy={0}
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2={-1}
          k3={1}
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.187972916 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-5">
        <stop stopColor="#F5E3FF" stopOpacity={0.663369345} offset="0%" />
        <stop stopColor="#FCF1FF" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="icon18/\u6D41\u7A0B\u5F00\u59CB"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M2.00837657,2 L2.7441778,2 C3.29646255,2 3.7441778,2.44771525 3.7441778,3 C3.7441778,3.01636561 3.74377605,3.03272875 3.74297291,3.04907464 L3.05509918,17.0490746 C3.02893218,17.5816404 2.5895123,18 2.05630407,18 L2.00837657,18 C1.45609182,18 1.00837657,17.5522847 1.00837657,17 L1.00837657,3 C1.00837657,2.44771525 1.45609182,2 2.00837657,2 Z"
        id="\u77E9\u5F62"
        fill="url(#linearGradient-1)"
      />
      <g id="\u77E9\u5F62">
        <use
          fill="url(#linearGradient-2)"
          fillRule="evenodd"
          xlinkHref="#path-3"
        />
        <use
          fill="black"
          fillOpacity={1}
          filter="url(#filter-4)"
          xlinkHref="#path-3"
        />
      </g>
      <path
        d="M10.0076068,4.76746255 L12.2198298,8.0857971 C12.4036413,8.36151432 12.329137,8.73403594 12.0534197,8.91784743 C11.9548592,8.98355443 11.8390546,9.01861725 11.7205996,9.01861725 L7.29615353,9.01861725 C6.96478267,9.01861725 6.69615351,8.74998809 6.69615351,8.41861723 C6.69615351,8.30016223 6.73121633,8.18435761 6.79692334,8.0857971 L9.00914637,4.76746255 C9.19295785,4.49174532 9.56547947,4.417241 9.8411967,4.60105248 C9.90710807,4.6449934 9.96366585,4.70155117 10.0076068,4.76746255 Z"
        id="\u4E09\u89D2\u5F62"
        fill="url(#linearGradient-5)"
        transform="translate(9.508377, 6.518617) rotate(-270.000000) translate(-9.508377, -6.518617) "
      />
    </g>
  </svg>
);
export default memo(Icon);
